export default {"src":"/_next/static/media/QQQ.5ac6ceef.svg","height":18,"width":18};